import React, { useEffect } from "react";
import Header from "./Header";
import SideDrawer from "./SideDrawer";
import "./NavigationLayout.scss";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { commonAction } from "../../../redux/features/commonSlice";

const NavigationLayout = ({ children }: { children: any }) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const homePageFilter = useSelector(
    (state: RootState) => state?.common?.homePageFilter
  );

  useEffect(() => {
    let root = document.getElementById("root");
    root?.classList.remove("root-overflow-hidden");
    if (homePageFilter) {
      dispatch(commonAction?.setHomePageFilter());
    }
  }, [location.pathname]);
  return (
    <div className="navigation_layout_container">
      <Header />
      <SideDrawer />
      <div className="layout_container">{children}</div>
    </div>
  );
};

export default NavigationLayout;
